const televizolarData = [
  {
    title: "Televizor mahsulotlari haqida ma'lumtolar",
    link: "Barcha mahsulotlar",
  },   
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
  },   
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
  },   
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
  },   
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
  },   
   
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
    options: {
      option1: "Mahsulot turi",
      option2: "Mahsulot turi",
      option3: "Mahsulot turi",
      option4: "Mahsulot turi",
      option5: "Mahsulot turi",
    }
  },  
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
  },
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
  },
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
  },
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
  },
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
  },
  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
  },

  {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
    options: {
      option1: "Mahsulot turi",
      option2: "Mahsulot turi",
      option3: "Mahsulot turi",
      option4: "Mahsulot turi",
      option5: "Mahsulot turi",
    }
  },   {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
    options: {
      option1: "Mahsulot turi",
      option2: "Mahsulot turi",
      option3: "Mahsulot turi",
      option4: "Mahsulot turi",
      option5: "Mahsulot turi",
    }
  },   {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
    options: {
      option1: "Mahsulot turi",
      option2: "Mahsulot turi",
      option3: "Mahsulot turi",
      option4: "Mahsulot turi",
      option5: "Mahsulot turi",
    }
  },   {
    title: "Mahsulot sarlavhasi",
    link: "Barcha mahsulotlar",
    options: {
      option1: "Mahsulot turi",
      option2: "Mahsulot turi",
      option3: "Mahsulot turi",
      option4: "Mahsulot turi",
      option5: "Mahsulot turi",
    }
  }, 
];

export default televizolarData;
